module.exports = __webpack_public_path__ + "static/img/banner.b6238ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2023default/index/banner.png
// module id = SiL3
// module chunks = 2